import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateMarketMembership from "./CreateMarketMembership";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMemberships } from "services/ConfigServices";
import { memberships } from "variables/markets";
import { membershipStatusData } from "variables/lists/markets";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useMembershipsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const marketsupdate = permis.includes("markets_update");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMemberships(chartIdGroup, market.id);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMemberships, setSelectedMemberships] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );


  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <CreateMarketMembership refetch={refreshTable} onClick={onUpload} />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, `memberships`, []).filter(
    (item) =>
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && membershipStatusData.find((x) => x.id == item.parameters.status) && membershipStatusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.groups && groupInfoListById["" + item.parameters.groups] && groupInfoListById["" + item.parameters.groups].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.dateupdate && moment(item.parameters.dateupdate).isValid() && moment(item.parameters.dateupdate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.daterequest && moment(item.parameters.daterequest).isValid() && moment(item.parameters.daterequest).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.datemembership && moment(item.parameters.datemembership).isValid() && moment(item.parameters.datemembership).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.marketmembershipnumber && item.parameters.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.internalmembershipnumber && item.parameters.internalmembershipnumber.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedMemberships.map((item) => {
      let membershiptoexport = {};
      membershiptoexport[memberships.name] = item.parameters.name;
      membershiptoexport[memberships.marketmembershipnumber] = item.parameters.marketmembershipnumber;
      membershiptoexport[memberships.internalmembershipnumber] = item.parameters.internalmembershipnumber;
      membershiptoexport[memberships.status] = membershipStatusData.find((x) => x.id == item.parameters.status)?.name;
      membershiptoexport[memberships.dateupdate] = (item.parameters.dateupdate && moment(item.parameters.dateupdate).isValid()) ? moment(item.parameters.dateupdate).format("DD/MM/YYYY") : "";
      membershiptoexport[memberships.daterequest] = (item.parameters.daterequest && moment(item.parameters.daterequest).isValid()) ? moment(item.parameters.daterequest).format("DD/MM/YYYY") : "";
      membershiptoexport[memberships.datemembership] = (item.parameters.datemembership && moment(item.parameters.datemembership).isValid()) ? moment(item.parameters.datemembership).format("DD/MM/YYYY") : "";
      membershiptoexport[memberships.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      membershiptoexport[memberships.groups] = (item.parameters.groups && groupInfoListById["" + item.parameters.groups]) ? groupInfoListById["" + item.parameters.groups] : "";
      membershiptoexport[memberships.contactname] = item.parameters.contactname;
      membershiptoexport[memberships.contactjob] = item.parameters.contactjob;
      membershiptoexport[memberships.company] = item.parameters.company;
      membershiptoexport[memberships.siret] = item.parameters.siret;
      membershiptoexport[memberships.phone] = item.parameters.phone;
      membershiptoexport[memberships.email] = item.parameters.email;
      membershiptoexport[memberships.billingaddress] = item.parameters.billingaddress?.description;
      membershiptoexport[memberships.comments] = item.parameters.comments;
      membershiptoexport[memberships.description] = item.parameters.description;
      return membershiptoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {marketsupdate && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateMarketMembership refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedMemberships || selectedMemberships.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedMemberships]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedMemberships,
  };
}
